import React from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import { useFormikContext } from "formik";
import { WidgetHeading, formikOptionConverter } from "@qgiv/core-donor";
import { selectCmsControlById } from "../../redux/slices/cmsSettingsSlice";

const ConnectedWidgetHeadingControl = ({ controlId }) => {
    // -------------------------------------------------------------------------
    // TODO: Trying nullish coalescing to handle WidgetHeading instances outside
    // of a Formik wrapper (Store and confirmation page). Need to test to see if
    // this solution works, otherwise we will have to get more specific about
    // which page can load what.
    // -------------------------------------------------------------------------
    const formikContext = useFormikContext() ?? { values: {} };
    const { values = {} } = formikContext;

    const hasEmptyFormikValues = Object.keys(values)?.length === 0;
    const control = useSelector((state) =>
        selectCmsControlById(controlId, state),
    );
    const { options = {} } = control;

    // Because formikOptionConverter takes in the options object
    // we need to destructure the text key from options separately
    // when we do not have a formik wrapper/missing formik values.
    if (hasEmptyFormikValues) {
        const { text } = options;
        return <WidgetHeading text={text} />;
    }

    const { text } = formikOptionConverter(options, values);
    return <WidgetHeading text={text} />;
};

ConnectedWidgetHeadingControl.propTypes = {
    controlId: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
        .isRequired,
};

export default ConnectedWidgetHeadingControl;
